"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RefreshButton = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
require("./DownloadButton.scss");
var RefreshButton = function (props) {
    var msg = (props.tooltipMessage) ? props.tooltipMessage : '';
    return (react_1.default.createElement("div", { className: classnames_1.default('refresh-button', { tooltip: props.showTooltip }, props.tooltipPosition), "data-tooltip": msg, style: { lineHeight: '1rem' } },
        react_1.default.createElement("a", { onClick: props.onRefresh },
            react_1.default.createElement("i", { className: classnames_1.default('fas', props.icon, props.className) }),
            !props.showTooltip &&
                react_1.default.createElement("p", { className: classnames_1.default(props.className) }, props.message))));
};
exports.RefreshButton = RefreshButton;
